var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.6667C7 17.219 7.44772 17.6667 8 17.6667H9.33333C9.88562 17.6667 10.3333 17.219 10.3333 16.6667V7C10.3333 6.44772 9.88562 6 9.33333 6H8C7.44771 6 7 6.44772 7 7V16.6667ZM14.6667 6C14.1144 6 13.6667 6.44772 13.6667 7V16.6667C13.6667 17.219 14.1144 17.6667 14.6667 17.6667H16C16.5523 17.6667 17 17.219 17 16.6667V7C17 6.44772 16.5523 6 16 6H14.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseDark);
export default __webpack_public_path__ + "static/media/pause_dark.f3ba658c077ba1ba58f459050187aa63.svg";
export { ForwardRef as ReactComponent };